import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD,
    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_BY_ID,

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE,

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE,

    ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE,

    IInstitutionItemTemplateCategoryLoadAction,
    IInstitutionItemTemplateCategoryLoadByIdAction,
    IInstitutionItemTemplateCategoryLoadFailureAction,
    IInstitutionItemTemplateCategoryLoadSuccessAction,

    IInstitutionItemTemplateCategorySaveAction,
    IInstitutionItemTemplateCategorySaveSuccessAction,
    IInstitutionItemTemplateCategorySaveFailureAction,

    IInstitutionItemTemplateCategoryCreateAction,
    IInstitutionItemTemplateCategoryCreateSuccessAction,
    IInstitutionItemTemplateCategoryCreateFailureAction,

    IInstitutionItemTemplateCategoryValidateAction,
    IInstitutionItemTemplateCategoryValidateSuccessAction,
    IInstitutionItemTemplateCategoryValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionItemTemplateCategories";
import { institutionItemTemplateCategoriesApi } from "../services/institutionItemTemplateCategories";


export const
    getInstitutionItemTemplateCategoriesEpic = (action$): Observable<IInstitutionItemTemplateCategoryLoadSuccessAction | IInstitutionItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD)
            .mergeMap((_action: IInstitutionItemTemplateCategoryLoadAction) => {
                return institutionItemTemplateCategoriesApi
                    .getInstitutionItemTemplateCategories()
                    .map(response =>
                        LoadSuccess(response.institutionItemTemplateCategories, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionItemTemplateCategoryByIdEpic = (action$): Observable<IInstitutionItemTemplateCategoryLoadSuccessAction | IInstitutionItemTemplateCategoryLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_LOAD_BY_ID)
            .mergeMap((action: IInstitutionItemTemplateCategoryLoadByIdAction) => {
                return institutionItemTemplateCategoriesApi
                    .getInstitutionItemTemplateCategoryById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionItemTemplateCategory, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionItemTemplateCategoryEpic = (action$): Observable<IInstitutionItemTemplateCategorySaveSuccessAction | IInstitutionItemTemplateCategorySaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_SAVE)
            .mergeMap((action: IInstitutionItemTemplateCategorySaveAction) => {
                return institutionItemTemplateCategoriesApi
                    .setInstitutionItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionItemTemplateCategoryEpic = (action$): Observable<IInstitutionItemTemplateCategoryCreateSuccessAction | IInstitutionItemTemplateCategoryCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_CREATE)
            .mergeMap((_action: IInstitutionItemTemplateCategoryCreateAction) => {
                return institutionItemTemplateCategoriesApi
                    .createInstitutionItemTemplateCategory()
                    .map(response =>
                        CreateSuccess(
                            response.institutionItemTemplateCategory,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionItemTemplateCategoryEpic = (action$): Observable<IInstitutionItemTemplateCategoryValidateSuccessAction | IInstitutionItemTemplateCategoryValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTION_ITEM_TEMPLATE_CATEGORIES_VALIDATE)
            .mergeMap((action: IInstitutionItemTemplateCategoryValidateAction) => {
                return institutionItemTemplateCategoriesApi
                    .validateInstitutionItemTemplateCategory(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionItemTemplateCategory, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



